import React from 'react';
import {
  FaAngleDoubleRight,
  FaArrowRight,
  FaCheckCircle,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import MICE from '../pages/MICE';

const MICEDetails = () => {
  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-12">
              <div className="td-sidebar service-sidebar">
                <div className="widget widget_catagory">
                  <h5 className="widget-title">
                    <FaArrowRight /> All Service lists
                  </h5>
                  <ul className="catagory-items">
                    <li>
                      <Link to="/AirTicketing"> Air Ticketing</Link>
                    </li>
                    <li>
                      <Link to="/TravelInsurance"> Travel Insurance</Link>
                    </li>
                     <li>
                       <Link to="/DomesticInternationalTours"> Domestic & International Tours</Link>
                     </li>
                    <li>
                      <Link to="/MICE"> MICE</Link>
                    </li>
                     <li>
                      <Link to="/PassportVisa"> Passport & Visa Assistance</Link>
                     </li>
                     <li>
                       <Link to="/HotelBooking"> Hotel Booking </Link>
                     </li>
                  </ul>
                </div>
                <div className="widget widget_author text-center">
                  <div className="thumb">
                    <img src="assets/img/about/9.png" alt="img" />
                  </div>
                  
                </div>
               
              </div>
            </div>
            <div className="col-lg-8">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  <div className="thumb">
                    <img src="assets/img/banner5.jpg" alt="img" />
                  </div>
                  <div className="details">
                  <h5>MICE – Meetings, Incentives, Conferences, Exhibitions</h5>
                    <h4>
                    Professional Corporate Travel Management
                    </h4>
                    <p>
                    At Bhavanya Travel Mart Pvt Ltd, we provide end-to-end MICE solutions.
                     From booking venues to travel coordination and accommodation,
                     we ensure your corporate events are executed seamlessly.
                    </p>
                   
                 
                    <h4>MICE Services Include:</h4>
                   
                    <div className="row">
                      <div className="col-md-12">
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> Flight & Hotel Arrangements
                          </li>
                          <li>
                            <FaCheckCircle /> Conference & Event Planning
                          </li>
                          <li>
                            <FaCheckCircle /> Local Transportation
                          </li>
                          <li>
                            <FaCheckCircle /> Sightseeing & Entertainment
                          </li>
                        </ul>
                      </div>
                      <div className="details">
                    <Link className="btn btn-base border-radius-5" to="tel:6363169466">
                    Trusted by corporates for professional event execution.
                    </Link>
                  </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default MICEDetails;
